import { ActionIcon, Modal } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { IconCalendar } from "@tabler/icons-react";
import { useState } from "react";
import CustomInput from "../CustomInput/CustomInput";
import { ICell } from "../Cell/Cell.types";
import { useInputProps } from "../hooks/useInputProps";
import dayjs from "dayjs";
import { toMantineDateString } from "src/utils/mantineDates";
import { useDisclosure } from "@mantine/hooks";

interface DateOrTextInputProps extends ICell {
  uuid: string;
  rowIndex?: number;
  colIndex?: number;
}

const DateOrTextInput = ({
  uuid,
  cell,
  tag,
  rowIndex,
  colIndex,
  ...props
}: DateOrTextInputProps & { cell: any }) => {
  const [opened, picker] = useDisclosure(false)
  const { onChange, value } = useInputProps(uuid, cell.value ?? "");

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          overflowY: "hidden"
        }}>
        <DatePickerInput
          value={toMantineDateString(value)}
          styles={{ input: { width: 0, height: 0, padding: 0, border: 0, visibility: "hidden" } }}
          popoverProps={{ opened, onDismiss: () => picker.close() }}
          onChange={date => {
            if (date) {
              onChange(dayjs(date).format("DD MMM YYYY"));
              picker.close();
            }
          }}
        />
        <CustomInput
          {...cell}
          tag={tag}
          id={uuid}
          domId={cell.id ?? ""}
          rowIdx={rowIndex}
          colIndex={colIndex}
          readonly={tag?.startsWith("OnyxPercTotal") ? true : cell.readonly}
          sectionIndex={cell.sectionIndex}
          style={{ flex: 1 }}
        />
        <ActionIcon
          color="blue"
          onClick={() => picker.open()}
          title="Open calendar">
          <IconCalendar size={18} />
        </ActionIcon>
      </div>


    </>
  );
};

export default DateOrTextInput;
